import z from 'zod'

export const ProviderUserManagementParams = z.object({
  providerId: z.string(),
})
